<template>
  <div>
    <!-- Start Header Area -->
    <Header default-color="black">
      <img
          slot="logo"
          src="../../assets/images/layout/smile-logo.svg"
          class="logo-light"
          style="max-width: 13rem"
          alt="Smile Magazine Logo"
      />
      <img
          slot="logo-dark"
          src="../../assets/images/layout/smile-logo.svg"
          class="logo-dark"
          alt="Smile Magazine Logo"
      />
    </Header>
    <!-- End Header Area -->

    <!-- Start Gallery Area  -->
    <div class="rn-gallery-area rn-section-gap bg_color--1 position-relative mt-16">
      <div class="rn-masonary-wrapper">
        <div class="wrapper plr--70 plr_sm--30 plr_md--30">
          <div class="be-custom-gallery">
            <Works />
          </div>
        </div>
      </div>
    </div>
    <!-- End Gallery Area  -->

    <!-- Start Footer Area  -->
    <Footer />
    <!-- End Footer Area  -->
  </div>
</template>
<script>
  import Header from "../layout/header/HeaderOnePage.vue"
  import Works from "../portfolio/sections/works.vue"
  import BannerTwo from "../../components/slider/BannerTwo";
  import Footer from "../../pages/layout/footer/Footer.vue";
  import Masonry from 'masonry-layout'
  export default {
    components: {
      Header,
      BannerTwo,
      Works,
      Footer,
    },
    data() {
      var grid = document.querySelector('.mesonry-list');
      var msnry = new Masonry( grid, {
        // options...
        itemSelector: '.masonry_item',
        columnWidth: 200,
        isAnimated: true
      });
      return {
        tab: null,
        index: null,
        tabItems: [
          {
            id: 1,
            name: "All Project",
          },
          {
            id: 2,
            name: "Web Design",
          },
          {
            id: 3,
            name: "Logo Design",
          },
          {
            id: 4,
            name: "Mobile App",
          },
        ],
        tabContent: [
          {
            id: 1,
            content: [
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-01.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-01.jpg"),
                tag: "Web Design",
                title: `T-shirt design is the part of design`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-02.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-02.jpg"),
                tag: "App Development",
                title: `The service provide for designer`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-03.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-03.jpg"),
                tag: "Web Design",
                title: `Mobile App landing Design`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-04.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-04.jpg"),
                tag: "Logo Design",
                title: `Logo Design creativity`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-05.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-05.jpg"),
                tag: "Web Design",
                title: `Getting tickets to the big show`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-06.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-06.jpg"),
                tag: "Web Design",
                title: `T-shirt design is the part of design`,
              },
            ],
          },
          {
            id: 2,
            content: [
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-03.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-03.jpg"),
                tag: "Web Design",
                title: `Mobile App landing Design`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-04.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-04.jpg"),
                tag: "Web Design",
                title: `Web Design creativity`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-05.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-05.jpg"),
                tag: "Web Design",
                title: `Getting tickets to the big show`,
              },
            ],
          },
          {
            id: 3,
            content: [
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-02.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-02.jpg"),
                tag: "Logo Design",
                title: `The service provide for designer`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-04.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-04.jpg"),
                tag: "Logo Design",
                title: `Logo Design creativity`,
              },
            ],
          },
          {
            id: 4,
            content: [
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-01.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-01.jpg"),
                tag: "Mobile App",
                title: `T-shirt design is the part of design`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-03.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-03.jpg"),
                tag: "Mobile App",
                title: `Mobile App landing Design`,
              },
              {
                thumb: require("../../assets/images/portfolio/dp-portfolio-05.jpg"),
                src: require("../../assets/images/portfolio/big/dp-big--portfolio-05.jpg"),
                tag: "Mobile App",
                title: `Getting tickets to the big show`,
              },
            ],
          },
        ],
      };
    },
  };
</script>
